import * as React from 'react';
import { generateCssForMarkdown } from '../../../../alan_btn/src/styles/markdown';
export function MarkdownStyle() {
    const css = generateCssForMarkdown('.with-markdown', '');
    return <style>{`${css}`}</style>;

}